import { indexBy } from 'ramda';

import * as globalTypes from 'constants/ActionTypes';
import * as appointmentsTypes from 'modules/appointments/actionTypes';
import * as types from 'modules/brands/actionsType';
import type { Brand, StatisticsBrand } from 'modules/brands/types';
import { mergeDeep } from 'utils/ObjectUtils';
import { createReducer } from 'utils/ReduxUtils';

type BrandsByIdState = Record<string, Partial<Brand> & { id: string; name: string }>;

const indexById = (items: Brand[]): BrandsByIdState => indexBy((item: Brand) => item.id as string, items) as BrandsByIdState;

const initialState: BrandsByIdState = {};

const fetchBrandSuccessReducer = (state: BrandsByIdState, { payload }: { payload: Brand }) => ({
  ...state,
  [payload.id]: { ...state?.[payload.id], ...payload },
});

const fetchBrandsSuccessReducer = (state: BrandsByIdState, { payload }: { payload: {content: Brand[]} }) =>
  mergeDeep(state, indexById(payload.content));

const fetchBrandsByDealerIdSuccessReducer = (state: BrandsByIdState, { payload }: { payload: {brands: Brand[]} }) =>
  mergeDeep(state, indexById(payload.brands));

const updateBrandsFromOthersDashboard = (state: BrandsByIdState, { payload }: { payload: { content: { brand: Brand }[] } }) => {
  const brands = payload.content.map(({ brand }) => brand);
  return {
    ...state,
    ...indexById(brands.map((brand: Brand) => ({ ...state?.[brand.id], ...brand }))),
  };
};

const fetchStatisticsBrands = (state: BrandsByIdState, action: { payload: {brands: StatisticsBrand[]} }) => {
  const { brands = [] } = action.payload;
  const data = brands.map((brand: StatisticsBrand) => ({
    id: brand?.brandId,
    name: brand?.brandName,
    ...brand,
  }));
  return fetchBrandsByDealerIdSuccessReducer(state, { payload: { brands: data } });
};

export default createReducer<BrandsByIdState>(initialState, {
  [types.FETCH_BRAND_SUCCESS]: fetchBrandSuccessReducer,
  [types.FETCH_ALL_BRANDS_SUCCESS]: fetchBrandsSuccessReducer,
  [types.FETCH_BRANDS_BY_GROUP_SUCCESS]: fetchBrandsByDealerIdSuccessReducer,
  [globalTypes.FETCH_STATISTICS_INTERVENTION_BRANDS_SUCCESS]: fetchStatisticsBrands,
  [types.FETCH_BRANDS_BY_DEALER_SUCCESS]: fetchBrandsByDealerIdSuccessReducer,
  [appointmentsTypes.FETCH_APPOINTMENTS_SUCCESS]: updateBrandsFromOthersDashboard,
});
